import {
	useTranslate,
} from "@pankod/refine-core";
import {
	Tag,
	SelectProps,
	Select
 } from "@pankod/refine-antd";

type RoomStatusProps = {
	status: "free" | "busy" | "soom" | "reserved" | "maintenance" | "closed";
};

export const RoomStatus: React.FC<RoomStatusProps> = ({ status }) => {
	const t = useTranslate();
  let color;
	switch (status) {
		case "free":
				color = "green";
				break;
		case "maintenance":
				color = "red";
				break;
		case "closed":
				color = "grey";
				break;
		case "busy":
				color = "blue";
				break;
		case "soom":
				color = "orange";
				break;
		case "reserved":
				color = "purple";
				break;
}
	
	return <Tag color={color}>{t(`enum.roomStatus.${status}`)}</Tag>;
};

export const SelectRoomStatus: React.FC<any> = () => {
	const t = useTranslate();
	const selectStatus: SelectProps['options'] = [
		{ value: "free", label: t("enum.roomStatus.free") },
		{ value: "busy", label: t("enum.roomStatus.busy") },
		{ value: "soom", label: t("enum.roomStatus.soom") },
		{ value: "reserved", label: t("enum.roomStatus.reserved") },
		{ value: "maintenance", label: t("enum.roomStatus.maintenance") },
		{ value: "closed", label: t("enum.roomStatus.closed") },
];
	return <Select options={selectStatus} defaultValue="free" />
};